// TODO: I use this enum because typescript has problem with boolean type and
// required string xD In future we can try change table function to fix this

export enum DeletedStatus {
  ToDeleted = "TO_DELETED",
  NoDeleted = "NO_DELETED",
}
